import { IFleetAppPerformance } from "../types/IFleetAppPerformance";
import { Api } from "./api";

export const GetFleetAppPerformance = async (): Promise<IFleetAppPerformance[]>  => {
    const api = await Api();

    const apiResponse = await api
        .get('dashboard-ui/performance')
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};
